import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Tag, Modal,Tabs,Checkbox,Input,Radio} from 'antd';
import {PropTypes} from 'prop-types';
import  './styleSectionKnowRelevance.css'
const TabPane = Tabs.TabPane;
class Relevance extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
        tab:'1',
        wordKnow:'',
        wordWrite:'',
        words:'',
    }

    componentDidMount(){

    }
    componentWillReceiveProps(nextProps){
        if(nextProps.visible&&!this.props.visible){
            this.setState({
                tab:'1',
                wordKnow:'',
                wordWrite:'',
                words:'',
            })
        }
    }

    onClick=(e,deep,item,know,selected)=>{
        if(item.list&&item.list.length){//非末级选中
            let arr=this.state[selected];
            arr[deep]=item.id;
            arr.splice(deep+1);
            this.setState({[selected]:arr})
        }else{                    //末级多选框选中
            let map = this.state[know]
            if(map.has(item.id)){
                map.delete(item.id)
            }else{
                map.set(item.id,item)
            }
            this.setState({[know]:map})
        }

    }


    addRelevance=()=>{
        let arr = []
        if(this.state.tab =='1'){
            if(this.state.wordKnow.length>0){
                arr.push({
                    "group": "会认",
                    "list": this.state.wordKnow.split('|')
                })
            }
            if(this.state.wordWrite.length>0){
                arr.push({
                    "group": "会写",
                    "list": this.state.wordWrite.split('|')
                })
            }
        }else{
            if(this.state.words.length>0){
                arr.push({
                    "group": "语文词语",
                    "list": this.state.words.split('|')
                })
            }
        }
        this.props.onOk(arr)
    }
    render() {

        return (
            <div>
                <Modal
                    title={'新增关联字词'}
                    visible={ this.props.visible}
                    onOk={ this.addRelevance }
                    onCancel={ ()=>{this.props.onCancel()} }
                >
                    <div style={{marginBottom:'20px'}}>
                        <div style={{fontSize: 14,marginLeft:'40px'}}>
                            <Radio.Group onChange={(e)=>{this.setState({tab:e.target.value})}} value={this.state.tab}>
                                <label style={{display:'inline-block'}} htmlFor="">请选择添加类型：</label>
                                <Radio value={'1'}>字</Radio>
                                <Radio value={'2'}>词</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    {
                        this.state.tab=='1'&&
                        <div>
                            <div style={{fontSize: 14,marginLeft:'40px',marginBottom:'20px'}}>
                                <label style={{width:'80px',display:'inline-block'}} htmlFor="">会认的字：</label>
                                <Input
                                    style={{ width: 150,marginRight:10}}
                                    onChange={(e)=>{if(e.target.value.length<30){this.setState({wordKnow:e.target.value});}}}
                                    value={this.state.wordKnow}
                                    placeholder={"输入字"}
                                />
                                <label style={{display:'inline-block'}} htmlFor="">多个字之间用'|'分开</label>
                            </div>

                            <div style={{fontSize: 14,marginLeft:'40px'}}>
                                <label style={{width:'80px',display:'inline-block'}} htmlFor="">会写的字：</label>
                                <Input
                                    style={{ width: 150,marginRight:10}}
                                    onChange={(e)=>{if(e.target.value.length<30){this.setState({wordWrite:e.target.value});}}}
                                    value={this.state.wordWrite}
                                    placeholder={"输入字"}
                                />
                            </div>
                        </div>
                    }

                    {
                        this.state.tab=='2'&&
                        <div>
                            <div style={{fontSize: 14,marginLeft:'40px'}}>
                                <label style={{width:'80px',display:'inline-block'}} htmlFor="">输入词语：</label>
                                <Input
                                    style={{ width: 150,marginRight:10}}
                                    onChange={(e)=>{if(e.target.value.length<30){this.setState({words:e.target.value});}}}
                                    value={this.state.words}
                                    placeholder={"输入词"}
                                />
                                <label style={{display:'inline-block'}} htmlFor="">多个词之间用'|'分开</label>
                            </div>

                        </div>
                    }

                </Modal>

            </div>
        )
    }
}

function mapState(state) {
    return {
        user:state.user
    };
}

function mapDispatch(dispatch) {
    return{

    }
}
export default connect(mapState, mapDispatch)(Relevance);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/SectionWordRelevance.js